(function (upp, angular, $UPP) {
    'use strict';

    /**
     * @typedef Country
     * @property {string} name
     * @property {string} iso3
     */

    /**
     * Provides acces to countries list and single search.
     * @class CountryApiService
     */
    CountryApiService.$inject = [ '$q', '$http' ];
    function CountryApiService($q, $http) {
        Object.defineProperties(this, {
            $q: { value: $q },
            $http: { value: $http },
        });
    }

    /**
     * Retrieves the available countries list.
     *
     * The value is cached after the first call to this method.
     * When cache is available, a copy if the cached value is
     * returning, meaning its safe to alter the returned list.
     *
     * @method CountryApiService#getCountries
     * @return {ng.IPromise<Country[]>}
     */
    CountryApiService.prototype.getCountries = function() {
        return this.$http({
            cache: true,
            method: 'GET',
            url: $UPP.URL_UPPLICATION_REST_SERVICE + 'users/countries',
        }).then(function(res) {
            // Return a deep copy for preventing possible
            // reference changes to the origial cached version.
            return angular.copy(res.data.countries);
        });
    }

    upp.service('countryApiService', CountryApiService);
}(upp, angular, $UPP));



// WEBPACK FOOTER //
// ./src/app/common/components/select-country/country-api.service.js